export default "__VITE_ASSET__QE1XBjSb__"